import { Injectable } from '@angular/core'
import { MenuModel } from './menu.model'
import { AjaxService } from 'src/app/shared/ajax.service'
import { GlobService } from 'src/app/shared/glob.service'

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  components: any[]
  cico
  cico_id: string

  constructor(private glob: GlobService, private ajax: AjaxService) {
    this.components = []
  }

  srt(level: any[], which: number, mod: number, row_id: string) {
    // which => 1.menu, 2.page | mod => 1.up, 2.down

    this.ajax.execute({
      url: 'menu/srt',
      data: { which, mod, row_id },
      success: (post: any) => {
        if (mod == 1)
          for (let i = 0; i < level.length - 1; i++)
            if (level[i].id == row_id) {
              level[i].srt++
              level[i + 1].srt--
              break;
            }

        if (mod == 2)
          for (let i = 1; i < level.length; i++)
            if (level[i].id == row_id) {
              level[i].srt--
              level[i - 1].srt++
              break;
            }
        level.sort((a, b) => { return a.srt - b.srt })
      }
    })
  }

  del(model: any, which: number, lev: any) {
    // which => 1.menu, 2.page
    if (!confirm('آیا مطمئن به حذف هستید؟')) return
    if (which == 2 && !confirm('با حذف صفحه تمامی محتوای آن از جمله گرید ها و فرم ها به صورت بازگشت ناپذیر حذف میگردد. آیا مطمئن به حذف هستید؟')) return

    this.ajax.execute({
      url: 'menu/del',
      data: { which, id: lev.id },
      success: (post: any) => {
        for (let i = 0; i < model.level1.length; i++)
          if (model.level1[i] === lev) model.level1.splice(i, 1)
          else for (let ii = 0; ii < model.level1[i].level2.length; ii++)
            if (model.level1[i].level2[ii] === lev) model.level1[i].level2.splice(ii, 1)
            else for (let iii = 0; iii < model.level1[i].level2[ii].level3.length; iii++)
              if (model.level1[i].level2[ii].level3[iii] === lev) model.level1[i].level2[ii].level3.splice(iii, 1)
              else if (model.level1[i].level2[ii].level3[iii].level4)
                for (let iiii = 0; iiii < model.level1[i].level2[ii].level3[iii].level4.length; iiii++)
                  if (model.level1[i].level2[ii].level3[iii].level4[iiii] === lev) model.level1[i].level2[ii].level3[iii].level4.splice(iiii, 1)
      }
    })
  }

  upd(which: number, item: any) {
    // which => 1.menu, 2.page
    this.ajax.execute({
      url: 'menu/upd',
      data: { which, id: item.id, tit: item.tit },
      success: (post: any) => {
        // level.sort((a, b) => { return a.srt - b.srt })
      }
    })
  }

  add(which: number, lev: any, level_no: number) {
    // which => 1.menu, 2.page
    var nam: string, tit: string
    if (which == 1) {
      tit = prompt('لطفا عنوان منوی جدید را وارد نمایید')
      if (!tit || tit == '') return
    }
    if (which == 2) {
      tit = prompt('لطفا عنوان صفحه جدید را وارد نمایید')
      if (!tit || tit == '') return
      nam = prompt('لطفا یک نام برای صفحه جدید (قابل مشاهده در url) ترجیحا به صورت انگلیسی وارد نمایید')
    }

    if (tit)
    this.ajax.execute({
        url: 'menu/add',
        data: { which, parent_id: level_no != 0 ? lev.id : '∅', tit, nam },
        success: (post: any) => {
          if (level_no == 0) {
            post.result[0].level2 = []
            lev.push(post.result[0])
          }

          if (level_no == 2) {
            post.result[0].level3 = []
            lev.level2.push(post.result[0])
          }

          if (level_no == 3) {
            if (which == 1) post.result[0].level4 = []
            lev.level3.push(post.result[0])
          }

          if (level_no == 4) {
            lev.level4.push(post.result[0])
          }
        }
      })
  }

  ico_brows(event, id: string) {
    this.cico_id = id
    this.cico = event.target
    document.getElementById('ico_menuid').click()
  }

  ico_set(event) {
    var formData = new FormData()
    formData.append('file', event.target.files[0])
    
    this.ajax.execute({
      url: 'menu/ico_set/' + this.glob.config.theme + '/' + this.cico_id,
      data: formData,
      type: 'post',
      contentType: false,
      processData: false,
      success: () => {
        this.cico.src = this.cico.src + '?t=' + new Date().getTime()
      }
    })
  }

  tab_changer(){
    // var someTabTriggerEl = document.querySelector('#someTabTrigger')
    // var tab = new bootstrap.Tab(someTabTriggerEl)
  
    // tab.show()
    $('#pages-tab').trigger('click')

  }
}
